import React, { useState, useEffect } from "react";
import { FaComments, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useApp } from "../../Context";

const ChatBubble = () => {
  const { showChatBubble } = useApp();
  const [isOpen, setIsOpen] = useState(false);

  // Synchronisiere mit Context-State
  useEffect(() => {
    if (showChatBubble) {
      setIsOpen(true);
    }
  }, [showChatBubble]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Bubble Button */}
      <motion.button
        onClick={toggleChat}
        className={`flex items-center justify-center w-16 h-16 rounded-full shadow-lg ${
          isOpen ? "bg-primary" : "bg-primary"
        } text-white transition-all duration-300 hover:scale-105`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        {isOpen ? (
          <FaTimes className="text-xl" />
        ) : (
          <FaComments className="text-2xl" />
        )}
      </motion.button>

      {/* Chat Dialog - immer im DOM, nur Animation und Sichtbarkeit ändern */}
      <div 
        className={`absolute bottom-20 right-0 w-[350px] h-[500px] md:w-[400px] md:h-[550px] bg-white rounded-lg shadow-xl overflow-hidden transition-all duration-300 ${
          isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        style={{
          transform: isOpen ? 'scale(1)' : 'scale(0.8)',
          transformOrigin: 'bottom right'
        }}
      >
        <div className="w-full h-full flex flex-col">
          <div className="flex-grow overflow-hidden">
            {/* iframe ist immer geladen, aber nur sichtbar wenn isOpen true ist */}
            <iframe
              src="https://immointerest.de/bot/"
              title="ImmoBot"
              className="w-full h-full border-none"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBubble;